import { Telegram } from 'education-icons';
import { Button, Link, Text, useIntl } from 'platform-components';
import React from 'react';

import './course-container-list__help-banner.scss';

export const CourseContainerHelpBanner = () => {
    const intl = useIntl();
    const link = intl.formatMessage({ id: 'courseContainerHelpBanner.button.link' });

    const messengerLink = intl.formatMessage({ id: 'courseContainerHelpBanner.contacts.messenger.link' });
    const communityLink = intl.formatMessage({ id: 'courseContainerHelpBanner.contacts.community.link' });

    return (
        <div className="course-container-list__help-banner">
            <div className="course-container-list__help-banner-contacts">
                <div className="course-container-list__help-banner-contacts-graphics" />
                <div className="course-container-list__help-banner-contacts-label">
                    <Text id="courseContainerHelpBanner.contacts.label" weight={Text.WEIGHT.M} />
                </div>
                <div className="course-container-list__help-banner-contacts-links">
                    <Link
                        className="course-container-list__help-banner-contacts-link-item"
                        target="_blank"
                        to={communityLink}
                    >
                        <Button
                            className="course-container-list__help-banner-contacts-link-button"
                            icon={<Telegram />}
                            transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                            view={Button.VIEW.PSEUDO}
                        />
                    </Link>
                    <Link
                        className="course-container-list__help-banner-contacts-link-item"
                        target="_blank"
                        to={messengerLink}
                    >
                        <Button
                            className="course-container-list__help-banner-contacts-link-button"
                            transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                            view={Button.VIEW.PSEUDO}
                        >
                            <Text id={'courseContainerHelpBanner.contacts.messenger.text'} />
                        </Button>
                    </Link>
                </div>
            </div>
            <div className="course-container-list__help-banner-content">
                <div className="course-container-list__help-banner-header">
                    <Text id={'courseContainerHelpBanner.header'} weight={Text.WEIGHT.M} />
                </div>
                <div className="course-container-list__help-banner-description">
                    <Text id={'courseContainerHelpBanner.description'} size={Text.SIZE.XL} />
                </div>
            </div>
            <Link className="course-container-list__help-banner-button" to={link}>
                <Button
                    size={Button.SIZE.L}
                    transparencyTheme={Button.TRANSPARENCY_THEME.DARK}
                    view={Button.VIEW.PSEUDO}
                >
                    <Text id={'courseContainerHelpBanner.button.text'} weight={Text.WEIGHT.M} />
                </Button>
            </Link>
        </div>
    );
};
